<template>
  <b-row class="footer">
    <b-col>
      <p class="menu">
        <template v-if="brand !== 'MelaniMethod'">
          <a href="https://dropsmarteo.com/support" target="_blank">FAQ and Support</a> |
        </template>
        <a href="https://dropsmarteo.com/terms-and-conditions" target="_blank">Terms of Service</a> |
        <a href="https://dropsmarteo.com/privacy" target="_blank">Privacy Policy</a>
      </p>
      <p class="copyright">{{ brand === 'MelaniMethod' ? '© Melani Method' : '© Dropsmart since 2016 (formerly Dropsmith)' }}</p>
    </b-col>
  </b-row>
</template>
<style lang="scss">
.footer {
  color: #434343;
  padding: 4% 0 3%;
  text-align: center;
  width: 100%;
  .menu {
    a {
      color: #434343;
      margin: 0 15px;
    }
  }
  .copyright {
    font-size: 18px;
    font-weight: 700;
  }
}
</style>

<script>
export default {
  props: {
    brand: { type: String, default: 'Dropsmart' }
  }
}
</script>
